import {
  addDoc,
  arrayRemove,
  arrayUnion,
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { firestore } from "../firebase";
import { Podcast, PodcastCollection } from "../types/Podcast";

function mapDocToPodcast(id: string, data: any): Podcast {
  return {
    id,
    ...data,
    userVotes: data.userVotes ?? [],
  };
}

export async function getPodcasts(): Promise<Podcast[]> {
  const podcastRef = collection(firestore, PodcastCollection);
  const podcastDocs = await getDocs(podcastRef);
  return podcastDocs.docs.map((doc) => {
    const data = doc.data();
    return mapDocToPodcast(doc.id, data);
  });
}

export async function createPodcast(
  podcast: Omit<Podcast, "id" | "userVotes">,
): Promise<Podcast> {
  // Use firebase to create a new podcast:
  const podcastRef = collection(firestore, PodcastCollection);
  const podcastDoc = await addDoc(podcastRef, podcast);

  return {
    ...podcast,
    id: podcastDoc.id,
    userVotes: [],
  };
}

export async function toggleUpvote(
  podcastId: string,
  userId: string,
): Promise<number> {
  const podcastRef = doc(firestore, PodcastCollection, podcastId);
  const podcastDoc = await getDoc(podcastRef);
  const podcast = mapDocToPodcast(podcastDoc.id, podcastDoc.data());

  if (!podcast) {
    throw new Error("Podcast not found");
  }

  const userVote = podcast.userVotes.find((vote) => vote.userId === userId);
  if (userVote) {
    // User has already voted, so remove the vote
    await updateDoc(podcastRef, {
      userVotes: arrayRemove(userVote),
    });
    return 0;
  }

  // User has not voted, so add the vote
  await updateDoc(podcastRef, {
    userVotes: arrayUnion({
      userId,
      vote: 1,
      timestamp: Date.now(),
    }),
  });
  return 1;
}
